import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";
import { Container } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { useSiteConfig } from "../../context/SiteConfigContext";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [metaData, setMetaData] = useState({});
  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const res = await blogAPI.details(slug, { limit: 4 });
      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;
        setItem(blog);
        setRelatedBlogs(relatedBlogs || []);
        setMetaData(blog?.meta || {});
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.title} middle="" />
      <SEO meta={metaData} />

      <div className="blog-detail-clean">
        <Container>
          <div className="blog-detail-grid">
            <main className="blog-detail-main">
              <div className="blog-detail-header">
                <span className="blog-detail-kicker">Journal / Story</span>
                <h1 className="blog-detail-title">{item?.title}</h1>

                <div className="blog-detail-meta">
                  <div className="blog-detail-author">
                    <div className="blog-detail-avatar">
                      {getInitials(item?.author)}
                    </div>
                    <div>
                      <h6>{item?.author}</h6>
                      <span>{formatDate(item?.date)}</span>
                    </div>
                  </div>
                </div>

                <p className="blog-detail-subtitle">{item?.shortDescription}</p>
              </div>

              <div className="blog-detail-image-wrap">
                <img
                  src={item?.image}
                  alt={item?.title}
                  className="blog-detail-image"
                />
              </div>

              <div
                className="blog-detail-content"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />
            </main>

            <aside className="blog-detail-sidebar">
              <div className="blog-detail-sidebar-inner">
                <h2 className="blog-detail-sidebar-title">Related Blogs</h2>

                {relatedBlogs.length > 0 && (
                  <div className="blog-detail-related-list">
                    {relatedBlogs.map((blog, index) => (
                      <div
                        key={blog._id || index}
                        className="blog-detail-related-item"
                      >
                        <BlogRelatedCard item={blog} />
                      </div>
                    ))}
                  </div>
                )}

                <div className="blog-detail-viewall-wrap">
                  <Link to="/blog" className="blog-detail-viewall">
                    View All
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </Container>
      </div>
    </>
  );
}

export default DetailPage;
